module.exports = __webpack_public_path__ + "img/bei.d0289dc0.png";